import React from 'react';
import { string, node } from 'prop-types';

const FooterItemBlock = ({ blockTitle, children }) => {
    return (<div
        className={'footer-item-block'}
    >
        <h2
            className={'footer-block-title'}
            style={{
                marginBottom:  blockTitle === '' ? '1em': '0'   
            }}
        >
            {blockTitle !== '' && blockTitle}
        </h2>
        <div
            className={'footer-block-content'}
        >
            {children}
        </div>
    </div>);
};

FooterItemBlock.propTypes = {
    blockTitle: string,
    children: node,
};

FooterItemBlock.defaultProps = {
    blockTitle: '',
};

export default FooterItemBlock;